const REFRESH = 'refresh';
const NO_REFRESH = 'noRefresh';

export {
  REFRESH,
  NO_REFRESH,
};
